import { render, staticRenderFns } from "./relationdata.vue?vue&type=template&id=77301170&scoped=true&"
import script from "./relationdata.vue?vue&type=script&lang=js&"
export * from "./relationdata.vue?vue&type=script&lang=js&"
import style0 from "./relationdata.vue?vue&type=style&index=0&id=77301170&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77301170",
  null
  
)

export default component.exports